import { render, staticRenderFns } from "./OrganizationItem.vue?vue&type=template&id=9264e01c&scoped=true&lang=html"
import script from "./OrganizationItem.vue?vue&type=script&lang=js"
export * from "./OrganizationItem.vue?vue&type=script&lang=js"
import style0 from "./OrganizationItem.vue?vue&type=style&index=0&id=9264e01c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9264e01c",
  null
  
)

export default component.exports